import { render, staticRenderFns } from "./DashboardFilterPanel.vue?vue&type=template&id=5b237bb2&"
import script from "./DashboardFilterPanel.vue?vue&type=script&lang=ts&"
export * from "./DashboardFilterPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports